<template>
  <!-- 分页 -->
  <a-pagination
      v-model:current="localCurrent"
      v-model:pageSize="localPageSize"
      :page-size-options="pageSizes"
      :show-total="(total) => `共 ${total} 条`"
      :total="pageTotal"
      class="pagination"
      show-quick-jumper
      show-size-changer
      size="small"
      @change="pageChange"
      @showSizeChange="onShowSizeChange"
  >
  </a-pagination>
</template>

<script>
import {reactive, toRefs, watch} from "vue";
import store from "@/store/pms/landlord/index";

export default {
  props: {
    pageTotal: {
      default: "0",
    },
    current: {
      type: Number,
      default: 1,
    },
    pageSize: {
      type: Number,
      default: 10,
    },
  },
  setup(props, context) {
    let pagination = reactive({
      localCurrent: props.current || 1,
      localPageSize: props.pageSize || store.getters.getPageSize,
      pageSizes: ["10", "20", "50", "100"],
      pageChange(value) {
        context.emit("pageChange", value);
      },
      onShowSizeChange(current, size) {
        context.emit("onShowSizeChange", size);
      },
    });

    watch(
        () => props.current,
        (val) => {
          pagination.localCurrent = val;
        }
    );

    watch(
        () => props.pageSize,
        (val) => {
          pagination.localPageSize = val;
        }
    );

    return {
      ...toRefs(pagination),
    };
  },
};
</script>

<style>
</style>
